<template>
  <div id="app">
    <app-header :app-title="$t('appTitle')">
      <template v-slot:mobile-nav>
        <mobile-nav>
          <ul>
            <li>
              <a href="/">{{ $t('home') }}</a>
            </li>
            <li>
              <a
                @click="showmodal"
              >{{ $t('disclaimer') }}</a>
            </li>
            <li class="revenue-link">
              <div class="is-size-6 text-uppercase">
                {{ $t('from') }}
              </div>
              <div class="text-uppercase">
                {{ $t('departmentof') }}
              </div>
              <div>
                <p>
                  <a
                    target="_blank"
                    href="https://www.phila.gov/departments/department-of-revenue/"
                  ><span class="has-text-weight-semibold revnue-link-symbol">{{ $t('revenue') }}</span><i
                    class="fa fa-external-link revnue-link-symbol"
                    aria-hidden="true"
                  /></a>
                </p>
              </div>
            </li>
          </ul>
        </mobile-nav>
      </template>
      <lang-selector
        slot="lang-selector-nav"
        :languages="languages"
      />
    </app-header>
    <main class="content container">
      <div class="columns">
        <div class="column is-full">
          <router-view />
        </div>
      </div>
      <related-content class="column hide-print is-mobile related-content-parent mb-6" />
    </main>
    <app-footer
      :is-hidden-mobile="false"
    >
      <div class="mb-1" />
      <ul class="hide-print only-desktop footer-content">
        <li class="pr-4">
          <a
            @click="showmodal"
          >{{ $t('disclaimer') }}</a>
        </li>
        <li>
          <a
            href="https://www.phila.gov/departments/department-of-revenue/"
            target="_blank"
          >{{ $t('department') }}</a>
        </li>
      </ul>
    </app-footer>
    <modal
      name="Disclaimer-popup-modal"
      height="auto"
      :adaptive="true"
      :focus-trap="true"
      styles=" overflow-y: auto;"
    >
      <div>
        <div class="example-modal-content">
          <div class="column is-full popup-header" />
          <div class="columns is-divider-popup mx-3 is-mobile">
            <div class="column is-4 has-text-weight-semibold modal-card-title pt-6 pl-0 mr-4">
              <p class="is-size-4">
                {{ $t('disclaimer') }}
              </p>
            </div>
            <div class="column is-2 is-offset-6">
              <a
                ref="fmodalclose"
                class="fas fa-times ml-6 close-btn"
                aria-label="close"
                @click="hidemodal"
              />
            </div>
          </div>
          <div class="mx-3">
            <p class="is-size-6 pb-3">
              {{ $t('disclaimerText') }}
            </p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { AppFooter,AppHeader, MobileNav } from '@phila/phila-ui';
import LangSelector from '@/components/LangSelector';
import RelatedContent from '@/components/RelatedContent';

export default {
  name: 'App',
  components: {
    AppHeader,
    LangSelector,
    AppFooter,
    MobileNav,
    'related-content':RelatedContent,
  },
  data () {
    return {
      languages: [
        {
          language: 'en-US',
          title: 'English',
        },
        {
          language: 'es',
          title: 'Spanish',
        },
      ],
    };
  },
  mounted(){
    if(!sessionStorage.getItem('firstVisit') == "1"){
      this.showmodal();
    }
  },
  methods:{
    showmodal () {
      this.$modal.show('Disclaimer-popup-modal');
      sessionStorage.setItem('firstVisit', '1');
    },
    hidemodal () {
      this.$modal.hide('Disclaimer-popup-modal');
    },
  },

};
</script>

<style lang="scss">
  @import "./assets/scss/main.scss";

  @media screen and (max-width:767px) {
    .vm--modal[style]{
      height: 100vh !important;
    }

    .title-col{
      a.app-title h1{
        font-size: 1.8rem !important;
        font-weight: 600 !important;
      }
    }

    .only-desktop{
      display: none;
    }

    .is-mobile.column {
      padding: 0;
    }

    .revenue-link {
      padding-top: 1rem;
      padding-bottom:4px;
      border-bottom:none !important;
    }

    .revenue-link div {
      color: white;
      font-size: 1.125rem;
      padding: 0 8rem 0 3rem;
      display: block;
      position: relative;
    }
    .revenue-link p  {
      border-bottom: 1px solid $electric-blue;
      color: $electric-blue;
    }

    .revenue-link i {
      float:right
    }

    .related-content-parent.is-mobile {
      padding-top: 50px;
    }
    .revnue-link-symbol{
      color:$electric-blue;
    }
    .close-btn {
      position: relative;
      background: transparent;
      border: none;
      color: #2176d2;
      font-size: 25px;
      top: 5px;
    }
    .example-modal-content .close-btn {
      margin-left: 0 !important
    }
  }
  #app-footer ul li{
    margin: 0 !important;
  }

  #app-footer ul li::after{
    display: inline-block;
    content: ' | ';
    border-right: 1px solid #fff;
    padding-right: 10px;
  }
    #app-footer ul li:last-child::after{
      content: '';
  }


  .footer-content a {
    text-decoration: underline;
  }

  #mobile-menu > ul > li > a.is-active, #mobile-nav.opened {
  background-color: $ben-franklin-blue-dark !important;
}

.input, .textarea, .select select{
  background-color:white !important;
}

</style>
